import axios from 'axios';

import { getFirebaseBackend } from 'helpers/firebaseHelper';

/**
 * Creates, updates or deletes the account's client at Big Serper through the backend, which
 * holds the Big Serper API key
 * @param {'create'|'update'|'delete'} action Operation on the client
 * @param {String} accountId Account's Unique Id
 * @param {Object} [client] Client data, required to create and update
 * @param {String} client.name Account's name
 * @param {String} client.domain Account's domain
 * @returns {Promise<Object>} Axios response
 */
const manageBigSerperClient = async (action, accountId, { name, domain } = {}) => {
  const firebaseToken = await getFirebaseBackend().getIdToken();

  return axios.post(
    `${process.env.REACT_APP_API_URL}/manageBigSerperClient`,
    {
      action,
      accountId,
      name,
      domain,
      development: process.env.REACT_APP_BUILD_TYPE !== 'production',
    },
    {
      headers: {
        Authorization: `Bearer ${firebaseToken}`,
      },
    },
  );
};

export { manageBigSerperClient };
